"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

var _extends2 = _interopRequireDefault(require("@babel/runtime/helpers/extends"));

var _objectWithoutPropertiesLoose2 = _interopRequireDefault(require("@babel/runtime/helpers/objectWithoutPropertiesLoose"));

var React = require('react');

var _require = require('gatsby'),
    Link = _require.Link;

var _require2 = require('../contexts/translated-routes-context'),
    useTranslatedRoutesContext = _require2.useTranslatedRoutesContext;

var _require3 = require('../contexts/translate-context'),
    useTranslateContext = _require3.useTranslateContext;

var Translate = require('./translate');

var _require4 = require('../utils'),
    clearSlugSlashes = _require4.clearSlugSlashes;

var TranslateLink = function TranslateLink(props) {
  var translatedRoutes = useTranslatedRoutesContext();

  var _useTranslateContext = useTranslateContext(),
      language = _useTranslateContext.language,
      isSourceLanguage = _useTranslateContext.isSourceLanguage;

  if (!Array.isArray(translatedRoutes)) {
    return /*#__PURE__*/React.createElement(Link, props, props.children);
  }

  var originalRoute = props.to,
      rest = (0, _objectWithoutPropertiesLoose2.default)(props, ["to"]);
  var translatedRoute = translatedRoutes.find(function (route) {
    return route.originalPath === clearSlugSlashes(originalRoute) && route.language === language;
  });
  var currentRoute = isSourceLanguage ? originalRoute : translatedRoute ? translatedRoute.translatedPath : originalRoute;
  return /*#__PURE__*/React.createElement(Link, (0, _extends2.default)({
    to: currentRoute
  }, rest), /*#__PURE__*/React.createElement(Translate, null, rest.children));
};

module.exports = TranslateLink;